export class ChatSound {
    constructor() {
        this.isChatSoundStart = false;
    }
    async sound(isChatEnabled) {
        let _this = this;
        let chatSound = document.getElementById("chatSound");
        if(chatSound)
        {
            //撥放完需關閉一次不然會沒辦法播下一次音效
            chatSound.onended = function() {
                _this.PlayEnd(this);
            };

            if (isChatEnabled && !_this.isChatSoundStart) {   
                _this.isChatSoundStart = true;          
                await _this.PlayStart(chatSound);

                _this.isChatSoundStart = false;
                _this.PlayEnd(chatSound);
            }
        }
    }

    async PlayStart(soundObj) {  
        return new Promise(async (resolve, reject) => {
            try {
                if(soundObj.limit) {
                    soundObj.limit();
                }
                this.PlayEnd(soundObj);

                await soundObj.play();
                soundObj.ToEnd = resolve;
            } catch(err) {
                console.error(err);                
                reject();
                this.isChatSoundStart = false;
            }
        });
    }

    PlayEnd (soundObj) {  
        this.PlayStop(soundObj);
        if(soundObj.ToEnd) {
            soundObj.ToEnd();
            soundObj.ToEnd = null;
        }
    }
    
    PlayStop(soundObj){
        soundObj.pause();
        soundObj.currentTime = 0;
    }
}

export default new ChatSound();